import PropTypes from 'prop-types';
import { useHelmet } from '@thd-nucleus/thd-helmet';
import { generateTags } from '../../utils/generate-tags';
import {
  buildSearchSchema,
  buildOrganizationSchema,
  buildPreloadImages,
  buildAlternateLinks
} from './homepage-helpers';
import { HD_URL, GOOGLE_SITE_VERIFICATION_ID, OPEN_GRAPH_FACEBOOK_ADMIN } from '../../constants';

const homepageMetadataHandler = ({ props }) => {
  const { metadata, preloadedImages = [] } = props || {};
  const {
    description,
    title,
    siteName,
    canonicalURL,
    type,
    alternate
  } = metadata;

  const schemas = [
    { content: buildSearchSchema(), id: 'site-search' },
    { content: buildOrganizationSchema(), id: 'site-organization' }
  ];

  let canonicalFullUrl = HD_URL;
  if (canonicalURL) {
    canonicalFullUrl = canonicalURL.startsWith('http') ? canonicalURL : `${HD_URL}${canonicalURL}`;
  }

  return generateTags({
    schemas,
    googleSiteVerification: GOOGLE_SITE_VERIFICATION_ID,
    preloadImages: buildPreloadImages(preloadedImages),
    description,
    ogDescription: description,
    ogTitle: title,
    title,
    ogSiteName: siteName,
    ogType: type,
    ogUrl: canonicalFullUrl,
    canonical: canonicalFullUrl,
    fbAdmins: OPEN_GRAPH_FACEBOOK_ADMIN,
    alternate: buildAlternateLinks(alternate)
  });
};

const HomepageMetadata = ({ metadata, preloadedImages }) => {

  const props = { metadata, preloadedImages };

  useHelmet('homepageMetadataHandler', { props }, homepageMetadataHandler);

  return null;
};

HomepageMetadata.displayName = 'HomepageMetadata';

HomepageMetadata.propTypes = {
  metadata: PropTypes.shape({}).isRequired,
  preloadedImages: PropTypes.arrayOf(PropTypes.shape({}))
};

export { HomepageMetadata };